import React from 'react';
import Tables from 'components/Table';
import { makeStyles } from '@material-ui/core';
import Figure from './Figure';
import {
  benchmarkFilter,
  formatName
} from 'components/Charts/Utils/benchmarks';
import { MetaType } from 'store/modules/Meta/types';

const { Table, TableRow, TableHead, TableCell } = Tables;

interface AnnualisedPerformanceTableProps {
  data: any;
  benchmarks?: Array<MetaType>;
}

const useStyles = makeStyles(theme => ({
  row: {
    '&:nth-child(even):not(.MuiTableRow-head)': {
      backgroundColor: '#f7f7f7'
    }
  },
  benchmarkRow: {
    color: theme.palette.primary.main
  }
}));

const AnnualisedPerformanceTable = ({
  data,
  benchmarks
}: AnnualisedPerformanceTableProps) => {
  const classes = useStyles();
  const keys = Object.keys(data || {}).filter((key: string) => key !== 'date');
  const headers = {
    '': null,
    '1y': { time: 1, period: 'year' },
    '3y': { time: 3, period: 'year' },
    '5y': { time: 5, period: 'year' }
  };

  return (
    <Table>
      <TableHead cells={['', '1y', '3y', '5y']} />
      {keys.map((key: string) => {
        const isBenchmark = benchmarkFilter(
          benchmarks?.map((benchmark: any) => benchmark.name),
          key
        );
        return (
          <TableRow
            className={`${classes.row} ${isBenchmark ? classes.benchmarkRow : ''}`}
            key={key}
          >
            <TableCell>
              <span style={{ fontWeight: 700 }}>{formatName(key)}</span>
            </TableCell>
            {Object.values(headers)
              .slice(1)
              .map((item: any, index: number) => {
                const figure =
                  data[key][
                    `annualised_${item.time}${item.period}_performance`
                  ] || {};
                return (
                  <TableCell key={index}>
                    <Figure
                      value={figure.value}
                      startDate={figure.startDate}
                      endDate={figure.endDate}
                    />
                  </TableCell>
                );
              })}
          </TableRow>
        );
      })}
    </Table>
  );
};

export default AnnualisedPerformanceTable;
